import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { NumericInput } from '@leverege/ui-elements';
import ValueThresholdizer from "./ValueThresholdizer.js";
export default function ValueThresholdizerEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(ValueThresholdizer, props);
  return /*#__PURE__*/React.createElement(NumericInput, {
    value: ValueThresholdizer.getValue(value),
    hint: "Threshold value",
    float: true,
    eventData: "setValue",
    onChange: onModelChange
  });
}
ValueThresholdizerEditor.isInline = true;